# Agent Group

The Agent Group specifies which agents the policy applies to. By default, it is set to 'aperture-cloud', indicating agents operating within your Aperture Cloud project.

If agents are self-hosted, agent group is set during agent installation as part of its configuration, while for agents in Aperture Cloud, it is always set to 'aperture-cloud'.
